export const ruLocale = {
  copyToast: {
    copiedToClipboard: 'Скопировано в буфер обмена!',
    subscriptionLinkUpdated: 'Ссылка была обновлена!',
    sessionsReset: 'Ваша сессия была сброшена',
  },
  common: {
    loading: 'Загрузка...',
    back: 'Назад',
    confirm: 'Подтвердить',
    cancel: 'Отмена',
    error: 'Произошла ошибка',
    dialogLabel: 'Диалоговое окно',
    currencySymbol: '₽',
    monthWords: {
      one: 'месяц',
      few: 'месяца',
      many: 'месяцев',
    },
  },
  uiFeedback: {
    prompt: {
      defaultTitle: 'Введите значение',
    },
    confirm: {
      defaultTitle: 'Подтверждение',
    },
  },
  navigation: {
    home: 'Главная',
    subscriptions: 'Подписки',
    balance: 'Баланс',
    referrals: 'Рефералы',
    catalog: 'Каталог',
    support: 'Поддержка',
    profile: 'Профиль',
  },
  home: {
    banner: {
      title: 'StrideVPN',
      description: 'Быстрый и приватный VPN с готовыми конфигурациями для ваших устройств.',
    },
    installGuideCardTitle: 'Руководство по установке',
    successModal: {
      title: 'Оплата прошла успешно!',
      description: 'Спасибо за оплату. Ваша конфигурация будет активирована автоматически.',
      confirmButton: 'Отлично!',
      ariaLabel: 'Подтверждение успешной оплаты',
    },
    selectPlan: 'Выбрать тариф',
  },
  homeLandingPage: {
    heading: 'Главная',
    hero: {
      title: 'Воспользуйтесь всеми функциями Astride VPN бесплатно.',
      activateTrialButton: 'Активировать бесплатно',
      trialHint: 'Бесплатно 3 дня, далее от 159 ₽ в мес.',
    },
    privacy: {
      headline: 'Конфиденциальность и безопасность. Это основа всего, что мы делаем.',
      cardTitle: 'Вы сами решаете, какими данными делиться. И с кем.',
    },
    issues: {
      message: 'Возникли проблемы с использованием? Легко сообщите о них через Astride.',
    },
    news: {
      title: 'Последние новости',
    },
    refund: {
      message: 'Нужен возврат средств? Служба поддержки Astride поможет.',
    },
    cta: {
      title: 'Попробуйте прямо сейчас.',
      goToSubscriptionsButton: 'Перейти в подписки',
    },
    countries: {
      title: 'Активные страны',
      items: [
        { id: 'germany', name: 'Германия' },
        { id: 'netherlands', name: 'Нидерланды' },
        { id: 'russia', name: 'Россия' },
      ],
    },
    articles: {
      title: 'Актуально сейчас',
      readButton: 'Читать',
      moreButton: 'Больше статей',
      items: [
        {
          id: 'vpn-setup',
          title: 'Как настроить VPN?',
          description: 'Чтобы обеспечить безопасность вашего интернет-соединения и защитить личные данные.',
        },
        {
          id: 'vpn-legal',
          title: 'Насколько это легально?',
          description: 'Чтобы избежать юридических рисков и соблюдать законы вашей страны при использовании интернета.',
        },
        {
          id: 'subscription-payment',
          title: 'Как оплатить подписку?',
          description: 'Чтобы выбрать безопасный способ оплаты и избежать блокировки подписки платежными системами.',
        },
      ],
    },
    actions: {
      comingSoon: 'Раздел будет доступен позже.',
      trialUnavailable: 'Бесплатная активация сейчас недоступна.',
    },
    trialPaymentForm: {
      ariaLabel: 'Активация бесплатного периода',
      closeAriaLabel: 'Закрыть форму активации',
      methodTitle: 'Astride VPN',
      changeMethodLabel: 'Способ оплаты',
      merchantName: 'Astride VPN',
      amountLabel: '0',
      payButton: 'Оплатить',
      processingButton: 'Активация...',
      paySuccessIndicatorAriaLabel: 'Бесплатный период активирован',
      alreadyUsedError: 'Пробный период уже использован.',
      unavailableError: 'Бесплатная активация сейчас недоступна.',
      activateError: 'Не удалось активировать пробный период.',
    },
  },
  installGuide: {
    ariaLabel: 'Руководство по установке',
    title: 'Установка VPN',
    subtitle: 'Выберите устройство, которое хотите подключить и следуйте инструкциям.',
    loading: {
      title: 'Подготавливаем руководство',
      subtitle: 'Загружаем шаги установки и ссылки для вашего устройства.',
      ariaLabel: 'Загрузка руководства по установке',
    },
    deviceLabel: 'Устройство',
    emptyState: 'Шаги установки временно недоступны.',
    subscriptionUrlUnavailable: 'Ссылка подписки недоступна',
    copySubscriptionUrlAriaLabel: 'Скопировать ссылку подписки',
    addSubscriptionLinkUnavailable: 'Ссылка подписки недоступна для добавления',
    errors: {
      loadSettingsFailed: 'Не удалось загрузить руководство по установке.',
    },
    buttons: {
      appStoreRu: 'App Store (RU)',
      appStoreGlobal: 'App Store (Global)',
      instructionsRu: 'На русском',
      instructionsEn: 'На английском',
      addSubscription: 'Добавить подписку',
    },
    steps: {
      installApp: {
        title: '1. Установка приложения',
        description:
          'Откройте страницу в App Store на Apple TV и установите приложение. Запустите его, предоставьте разрешение на VPN-конфигурацию, если потребуется, введите свой пароль.',
      },
      instructions: {
        title: '2. Инструкции по установке',
        description: 'Подробные инструкции, чтобы помочь вам настроить Happ на вашем устройстве.',
      },
      addSubscription: {
        title: '3. Добавление подписки',
        description: 'Нажмите кнопку ниже, чтобы открыть приложение и автоматически добавить подписку.',
      },
      connect: {
        title: '3. Подключение и использование',
        description: 'Откройте приложение и подключитесь к серверу.',
      },
    },
    devices: {
      appleTv: 'Apple TV',
    },
  },
  happRedirect: {
    loading: 'Открываем Happ...',
    invalidTarget: 'Ссылка для добавления подписки недействительна.',
  },
  payHandoff: {
    loading: 'Открываем оплату...',
    error: 'Не удалось открыть страницу оплаты. Вернитесь в приложение и попробуйте снова.',
  },
  catalog: {
    title: 'Выберите тариф',
    subtitle: 'Все тарифы включают неограниченную скорость и трафик.',
    tariffsLabel: 'Тарифы',
  },
  plan: {
    ariaLabel: 'Выбор тарифа',
    selectionTitle: 'Выберите тариф',
    selectionSubtitle: 'Все тарифы включают неограниченную скорость и трафик.',
    professionalSubscriptionLabel: 'Профессиональная подписка',
    continueWithSelectedTariff: 'Продолжить с выбранным тарифом',
    savingsPrefix: 'выгода',
    perMonthSuffix: '/ в месяц',
    proPackageLabel: 'Пакет Pro',
    unavailableTitle: 'Тариф недоступен',
    unavailableSubtitle: 'Не удалось загрузить данные тарифа. Попробуйте позже.',
  },
  auth: {
    paymentSuccess: {
      title: 'Оплата прошла успешно! 🎉',
      description: 'Ваша подписка активирована.',
      buttonOk: 'OK',
    },
  },
  profile: {
    defaultDisplayName: 'Пользователь',
    avatar: {
      fallbackLetter: 'U',
      telegramDefaultFirstName: 'Default',
      telegramDefaultUsername: 'default_user',
    },
    menu: {
      settings: 'Настройки',
      telegramChannel: 'Канал в Telegram',
      telegramCommunity: 'Сообщество в Telegram',
      userAgreement: 'Пользовательское соглашение',
      privacyPolicy: 'Политика конфиденциальности',
      help: 'Помощь',
      sharedAccess: 'Общий доступ',
      support: 'Служба поддержки',
      subscriptions: 'Подписки',
      transactions: 'Транзакции',
      referralProgram: 'Реферальная программа',
    },
    toasts: {
      linkUnavailable: 'Ссылка временно недоступна',
      sharedAccessUnavailable: 'Общий доступ пока недоступен',
      settingsComingSoon: 'Раздел настроек появится позже',
      helpComingSoon: 'Раздел помощи появится позже',
    },
  },
  userDashboard: {
    layout: {
      title: 'Профиль',
      subtitle: 'Управляйте подпиской и платежами',
    },
    loadingData: 'Загрузка данных...',
    loadErrorTitle: 'Ошибка загрузки данных',
    retryButton: 'Повторить',
    userFallbackName: 'Пользователь',
    userFallbackUsername: 'unknown',
    userIdPrefix: 'ID:',
    userFallbackAvatarLetter: 'U',
    stats: {
      activeSubscriptions: 'Активных подписок',
      totalSpent: 'Потрачено всего',
    },
    subscription: {
      title: 'Статус подписки',
      statusLabel: 'Статус:',
      activeStatus: 'Активна',
      accessModeLabel: 'Режим доступа:',
      fullAccess: 'Полный доступ',
      noAccess: 'Нет доступа',
    },
    paymentHistory: {
      title: 'История платежей',
      emptyState: 'Платежей еще нет',
      itemTitle: 'VPN Config',
      statuses: {
        completed: 'Завершено',
        pending: 'В обработке',
        failed: 'Ошибка',
      },
    },
    logoutButton: 'Выход',
  },
  adminPanel: {
    layout: {
      title: 'Админ-панель',
      subtitle: 'Контроль платежей и статистика',
    },
    stats: {
      totalRevenue: 'Общая выручка',
      totalPayments: 'Всего платежей',
      average: 'Среднее',
      completed: 'Завершено',
      errors: 'Ошибок',
    },
    management: {
      title: 'Управление',
      balanceManagerButton: '💰 Управление балансами',
      exportDataButton: '📊 Экспорт данных',
      syncButton: '🔄 Синхронизация',
      settingsButton: '⚙️ Настройки',
      cleanupButton: '🔴 Очистка',
      toggleBalanceManagerAriaLabel: 'Открыть или закрыть управление балансами',
      exportDataAriaLabel: 'Экспортировать данные',
      syncAriaLabel: 'Запустить синхронизацию',
      settingsAriaLabel: 'Открыть настройки',
      cleanupAriaLabel: 'Запустить очистку данных',
    },
    balanceManager: {
      title: '💰 Управление балансом пользователя',
      searchLabel: 'Поиск пользователя',
      searchPlaceholder: 'Username или Telegram ID',
      searchButton: 'Найти',
      searchButtonAriaLabel: 'Найти пользователя по username или Telegram ID',
      telegramIdLabel: 'ID:',
      balanceLabel: 'Баланс:',
      amountLabel: 'Сумма',
      amountPlaceholder: 'Введите сумму',
      descriptionLabel: 'Описание операции',
      descriptionPlaceholder: 'Например: Бонус за акцию',
      addButton: '➕ Пополнить',
      subtractButton: '➖ Списать',
      addButtonAriaLabel: 'Пополнить баланс пользователя',
      subtractButtonAriaLabel: 'Списать средства с баланса пользователя',
    },
    alerts: {
      enterSearchQuery: 'Введите username или Telegram ID',
      userNotFound: 'Пользователь не найден',
      searchError: 'Ошибка поиска пользователя',
      invalidAmount: 'Некорректная сумма',
      enterDescription: 'Введите описание операции',
      successAdd: 'Баланс пополнен успешно',
      successSubtract: 'Баланс списан успешно',
      manageBalanceError: 'Ошибка при управлении балансом',
    },
    footer: {
      versionPrefix: 'Version',
      adminModeLabel: 'Admin Mode',
    },
  },
  checkout: {
    unauthorized: 'Пользователь не авторизован',
    fallbackPackageName: 'Подписка',
    paymentDescriptionTemplate: '{package} ({count} {deviceWord})',
    paymentLinkUnavailable: 'Ссылка на оплату временно недоступна',
    paymentCreateError: 'Ошибка при создании платежа',
    title: 'Устройства',
    description: 'Выберите количество устройств для оплаты подписки.',
    modalAriaLabel: 'Окно выбора устройств',
    closeButtonAriaLabel: 'Закрыть окно выбора устройств',
    devicesInSubscription: 'Устройств в подписке',
    saveButton: 'Сохранить',
    processing: 'Обработка...',
    payPrefix: 'Оплатить',
    paymentFormAriaLabel: 'Форма оплаты подписки',
    paymentFormCloseAriaLabel: 'Закрыть форму оплаты подписки',
    sbpMethodTitle: 'СБП',
    paymentMethods: {
      sbp: 'СБП',
      balance: 'Баланс',
    },
    changeMethodButton: 'Изменить способ оплаты',
    changeMethodUnavailable: 'Смена способа оплаты скоро появится',
    merchantName: 'Astride',
    payButton: 'Оплатить',
    payWithBalanceButton: 'Оплатить',
    awaitingPaymentStatus: 'Ожидаем подтверждение оплаты...',
    paySuccessIndicatorAriaLabel: 'Оплата успешно выполнена',
    balanceMethodUnavailable: 'Оплата с баланса недоступна для выбранного тарифа',
    balancePurchaseSuccess: 'Подписка оплачена с баланса',
    balanceInsufficientFallback: 'Недостаточно средств на балансе. Переключаю на СБП',
    balancePurchaseError: 'Не удалось оплатить с баланса',
    paymentTrackingUnavailable: 'Не удалось отследить статус оплаты. Попробуйте позже.',
    paymentPending: 'Платеж пока не завершен. Ожидаем подтверждение.',
    paymentWaitTimeout: 'Оплата еще обрабатывается. Проверьте статус чуть позже.',
    paymentCancelled: 'Платеж отменен.',
    paymentFailed: 'Оплата не прошла.',
  },
  paymentPage: {
    configNotSelected: 'Конфиг не выбран',
    backToCatalog: 'Вернуться в каталог',
    descriptionPrefix: 'Оплата конфигурации',
    title: 'Оплата',
    subtitle: 'Подтвердите выбранный тариф',
    total: 'Итого',
    successCreated: 'Платеж успешно создан!',
    paymentMethod: 'Способ оплаты',
    paymentMethodCard: 'Карта',
    paymentMethodWallet: 'Кошелек',
    processing: 'Обработка...',
    pay: 'Оплатить',
    termsAgreement: 'Нажимая кнопку оплаты, вы соглашаетесь с условиями сервиса',
    genericError: 'Ошибка платежа',
  },
  referral: {
    title: 'Приглашайте друзей - Получайте бонусные дни',
    description: 'Получайте 15% от времени подписки друзей в виде бонусных дней. Награды начисляются автоматически при каждом продлении подписки.',
    modalAriaLabel: 'Реферальная программа',
    invitedCount: 'Приглашено',
    bonusDays: 'Получено бонусных дней',
    loadingShort: '...',
    copied: '✓ Скопировано!',
    copyFailed: 'Не удалось скопировать ссылку',
    copyLink: 'Скопировать ссылку',
    share: 'Поделиться',
    shareText: 'Присоединяйся к Astride VPN!',
  },
  referralsPage: {
    ariaLabel: 'Рефералы',
    stats: {
      totalReferralsLabel: 'Всего рефералов',
      activeReferralsTemplate: '{count} активных',
      totalEarningsLabel: 'Общий заработок',
      commissionLabel: 'Комиссия',
      autoAccrualHint: 'Награды начисляются автоматически при каждом продлении.',
    },
    link: {
      title: 'Ваша ссылка',
      cabinetLabel: 'Личный кабинет',
      unavailableValue: 'Ссылка недоступна',
    },
    rules: {
      percentTitle: 'Процентные отчисления',
      percentDescription: 'За каждого нового пользователя, приведенного по вашей ссылке, вы получите дополнительный процент от его покупок и дни подписки каждый раз, когда ваш друг продлит подписку.',
      giftsTitle: 'Бонусные подарки',
      giftsDescription: 'За каждые 2000 рублей, потраченные приглашёнными пользователями, вы получаете бонус и дополнительное устройство к своей подписке.',
    },
    actions: {
      referralsList: 'Ваши рефералы',
    },
    placeholders: {
      loadingShort: '...',
      notAvailable: '—',
    },
    toasts: {
      loadError: 'Не удалось загрузить реферальные данные',
      referralLinkUnavailable: 'Реферальная ссылка недоступна',
      copyFailed: 'Не удалось скопировать ссылку',
      cabinetComingSoon: 'Раздел личного кабинета скоро появится',
      referralsListComingSoon: 'Список рефералов скоро появится',
    },
  },
  referralsListPage: {
    ariaLabel: 'Ваши рефералы',
    title: 'Ваши рефералы',
    emptyDescription: 'Пока нет рефералов. Поделитесь ссылкой, чтобы пригласить друзей.',
    fallbackDisplayName: 'Пользователь',
    fallbackHandleTemplate: '@id{id}',
    status: {
      active: 'Активен',
      inactive: 'Неактивен',
    },
    dateUnavailable: '—',
    placeholders: {
      loadingShort: '...',
    },
    toasts: {
      loadError: 'Не удалось загрузить список рефералов',
      referralLinkUnavailable: 'Реферальная ссылка недоступна',
      copyFailed: 'Не удалось скопировать ссылку',
      cabinetComingSoon: 'Раздел личного кабинета скоро появится',
    },
  },
  referralDetailsModal: {
    ariaLabel: 'Выбранный реферал',
    closeAriaLabel: 'Закрыть выбранного реферала',
    fallbackDisplayName: 'Пользователь',
    fallbackHandleTemplate: '@id{id}',
    fallbackUnknownId: 'unknown',
    dateUnavailable: '—',
    details: {
      sectionTitle: 'Подробности',
      registrationLabel: 'Регистрация',
      startPercentLabel: 'Процент на старте',
      incomeLabel: 'Доход',
      percentUnavailable: '—',
      incomeUnavailable: '—',
    },
    expenses: {
      sectionTitle: 'Расходы реферала',
      emptyText: 'Расходов пока нет',
      titleFallback: 'Подписка Pro',
      typeFallback: 'Покупка',
      merchantFallback: 'Astride',
      amountUnavailable: '—',
    },
    status: {
      loading: 'Загрузка...',
      active: 'Активен',
      inactive: 'Неактивен',
    },
    placeholders: {
      loadingShort: '...',
    },
    toasts: {
      invalidReferral: 'Некорректный идентификатор реферала',
      loadError: 'Не удалось загрузить детали реферала',
    },
  },
  referralCommissionModal: {
    ariaLabel: 'Комиссия',
    closeAriaLabel: 'Закрыть окно комиссии',
    summary: {
      totalLabel: 'Всего',
      percentTemplate: '{percent} %',
      hintText: 'Процентные отчисления зависят от числа приглашенных пользователей.',
    },
    details: {
      title: 'Подробности',
      invitedLabel: 'Приглашено',
      inactiveLabel: 'Неактивны',
    },
    terms: {
      title: 'Условия комиссии',
      activeUsersLabel: 'Активных пользователей',
      percentTemplate: '{percent} %',
    },
    placeholders: {
      loadingShort: '...',
    },
    toasts: {
      loadError: 'Не удалось загрузить данные комиссии',
    },
  },
  referralTotalEarningsModal: {
    ariaLabel: 'Общий заработок',
    closeAriaLabel: 'Закрыть окно общего заработка',
    avatarAlt: 'Аватар реферала',
    fallbackDisplayName: 'Пользователь',
    fallbackHandleTemplate: '@id{id}',
    fallbackDate: '—',
    emptyText: 'Начислений пока нет',
    summary: {
      totalLabel: 'Всего',
    },
    placeholders: {
      loadingShort: '...',
      amountNotAvailable: '—',
    },
    toasts: {
      loadError: 'Не удалось загрузить общий заработок',
    },
  },
  transactions: {
    topupPrompt: 'Введите сумму пополнения (₽):',
    invalidAmount: 'Некорректная сумма',
    missingStatus: 'нет статуса',
    unknownError: 'неизвестная ошибка',
    statusLabel: 'Статус',
    errorLabel: 'Ошибка',
    paymentCreateErrorWithDetails: 'Ошибка при создании платежа\n\n',
    creatingPayment: 'Создаю платеж...',
    paymentCreatedOpening: 'Платеж создан! Открываю ссылку...',
    paymentLinkUnavailable: 'Ссылка на оплату временно недоступна',
    missingPaymentLink: 'Нет ссылки на оплату в ответе',
    paymentCreateError: 'Ошибка при создании платежа',
    balanceTitle: 'Доступный баланс',
    activityTitle: 'Активность',
    modalAriaLabel: 'История транзакций и баланс',
    emptyTitle: 'Транзакций пока нет',
    emptyDescription: 'Здесь будут отображаться все ваши платежи.',
    selectPlan: 'Выбрать тариф',
    topupBalance: 'Пополнить баланс',
    partyStride: 'Stride',
    partyUserFallback: 'Пользователь',
    packageFallback: 'Пакет',
    titleNormalization: {
      quickBuyPrefixes: [
        'Quick buy via balance:',
        'Quick buy:',
      ],
      packagePrefixes: [
        'Пакет',
      ],
      subscriptionPrefix: 'Подписка',
    },
    purchaseIconAlt: 'Иконка покупки',
    transactionIconAlt: 'Иконка транзакции',
    amountSigns: {
      positive: '+',
      negative: '-',
    },
    types: {
      purchase: 'Покупка',
      refund: 'Возврат',
      topup: 'Пополнение',
      adminAdd: 'Пополнение',
      adminSubtract: 'Списание',
    },
    details: {
      modalTitle: 'Справка',
      closeAriaLabel: 'Закрыть окно справки по транзакции',
      detailsTitle: 'Подробности',
      fallbackValue: '—',
      partyLabels: {
        sender: 'Отправитель',
        recipient: 'Получатель',
      },
      fields: {
        amount: 'Сколько',
      },
      categories: {
        purchase: 'Покупка',
        gift: 'Подарки',
        topup: 'Пополнение',
        refund: 'Возврат',
        adminAdd: 'Начисление',
        adminSubtract: 'Списание',
      },
      headerTitles: {
        purchaseFallback: 'Покупка',
        topup: 'Пополнение баланса',
        refund: 'Возврат средств',
        adminAdd: 'Начисление баланса',
        adminSubtract: 'Списание с баланса',
      },
      counterparties: {
        serviceName: 'Astride',
        adminName: 'Администратор',
        recipientFallback: 'Получатель',
      },
    },
  },
  balancePage: {
    ariaLabel: 'Баланс',
    sections: {
      history: 'История',
      monthlyExpensesTemplate: 'Расходы в {month}',
    },
    actions: {
      topup: 'Пополнить',
      settings: 'Настройки',
    },
    settingsModal: {
      ariaLabel: 'Настройки баланса',
      closeAriaLabel: 'Закрыть настройки баланса',
      openSupportChatUnavailable: 'Ссылка на поддержку недоступна',
      revealBalanceButton: 'Показать баланс',
      revealHistoryButton: 'Показать историю',
      hiddenBalanceLabel: 'Баланс скрыт',
      hiddenHistoryLabel: 'История скрыта до нажатия',
      noExpenseCardsSelected: 'Выберите хотя бы одну категорию расходов',
      sections: {
        balanceVisibility: 'Скрытие баланса',
        appEntry: 'Вход в приложение',
        expenses: 'Расходы',
        support: 'Служба поддержки',
      },
      rows: {
        hideBalanceOnEntry: 'Входить в Astride со скрытым балансом',
        hideHistoryPreviewOnEntry: 'Скрывать предпросмотр истории',
        showExpensesOnMainScreen: 'Отображать расходы на главном экране',
        showAllExpensesOnMainScreen: 'Все траты',
        showPurchasesOnMainScreen: 'Покупки',
        showGiftsInHistoryPreview: 'Подарки',
      },
      supportButton: 'Открыть чат',
    },
    stats: {
      allExpenses: 'Все траты',
      purchases: 'Покупки',
      gifts: 'Подарки',
    },
    topup: {
      modalTitle: 'Пополнение',
      modalDescription: 'Выберите сумму, чтобы пополнить счёт и используйте эти средства для покупок и подписок на сервисы Astride.',
      amountLabel: 'Сумма',
      amountPlaceholder: '0,0',
      nextButton: 'Далее',
      termsButton: 'Продолжая, вы соглашаетесь с условиями и положениями.',
      closeAriaLabel: 'Закрыть окно пополнения',
      invalidAmount: 'Некорректная сумма',
      amountTooLarge: 'Сумма превышает допустимый лимит',
      paymentCreated: 'Платеж создан! Открываю ссылку...',
      paymentLinkUnavailable: 'Ссылка на оплату временно недоступна',
      paymentCreateError: 'Ошибка при создании платежа',
    },
    topupPaymentForm: {
      ariaLabel: 'Форма оплаты пополнения баланса',
      closeAriaLabel: 'Закрыть форму оплаты',
      sbpMethodTitle: 'СБП',
      changeMethodButton: 'Изменить способ оплаты',
      changeMethodUnavailable: 'Смена способа оплаты скоро появится',
      merchantName: 'Astride',
      payButton: 'Оплатить',
      processingButton: 'Обработка...',
      awaitingPaymentStatusButton: 'Ожидаем подтверждение оплаты...',
      missingAmountError: 'Не удалось определить сумму пополнения',
      paymentTrackingUnavailable: 'Не удалось отследить статус оплаты. Попробуйте позже.',
      paymentPending: 'Платеж пока не завершен. Ожидаем подтверждение.',
      paymentWaitTimeout: 'Оплата еще обрабатывается. Проверьте статус чуть позже.',
      paymentCancelled: 'Платеж отменен.',
      paymentFailed: 'Оплата не прошла.',
      paySuccessIndicatorAriaLabel: 'Пополнение успешно выполнено',
    },
    history: {
      empty: 'История пока пуста',
    },
    monthsPrepositional: [
      'январе',
      'феврале',
      'марте',
      'апреле',
      'мае',
      'июне',
      'июле',
      'августе',
      'сентябре',
      'октябре',
      'ноябре',
      'декабре',
    ],
  },
  balanceHistoryPage: {
    ariaLabel: 'История баланса',
    searchPlaceholder: 'Поиск',
    filters: {
      hideGifts: 'Без подарков',
    },
    stats: {
      expenses: 'Траты',
      incomes: 'Доходы',
    },
    history: {
      empty: 'История пока пуста',
      giftTypeLabel: 'Подарок',
      dayLabels: {
        today: 'Сегодня',
        yesterday: 'Вчера',
      },
    },
    monthsNominative: [
      'Январь',
      'Февраль',
      'Март',
      'Апрель',
      'Май',
      'Июнь',
      'Июль',
      'Август',
      'Сентябрь',
      'Октябрь',
      'Ноябрь',
      'Декабрь',
    ],
  },
  balanceExpensesPage: {
    ariaLabel: 'Траты',
    searchPlaceholder: 'Поиск',
    tabs: {
      expenses: 'Траты',
      incomes: 'Доходы',
    },
    periods: {
      week: 'Нед',
      month: 'Мес',
      year: 'Год',
    },
    summary: {
      expensesLabel: 'Траты',
    },
    categories: {
      purchases: 'Покупки',
      gifts: 'Подарки',
    },
    history: {
      empty: 'Траты за выбранный период не найдены',
      giftTypeLabel: 'Подарок',
    },
    toasts: {
      incomesComingSoon: 'Раздел доходов скоро появится',
      loadError: 'Не удалось загрузить траты',
    },
  },
  balanceIncomesPage: {
    ariaLabel: 'Доходы',
    searchPlaceholder: 'Поиск',
    tabs: {
      expenses: 'Траты',
      incomes: 'Доходы',
    },
    periods: {
      week: 'Нед',
      month: 'Мес',
      year: 'Год',
    },
    summary: {
      incomesLabel: 'Доходы',
    },
    categories: {
      interest: 'Проценты',
      bonuses: 'Бонусы',
      topups: 'Пополнения',
    },
    history: {
      empty: 'Доходы за выбранный период не найдены',
      subtitles: {
        interest: 'Проценты',
        bonuses: 'Зачисление',
        topups: 'Пополнение',
      },
      fallbackTitles: {
        interest: 'Реферальный бонус',
        bonuses: 'Бонусы',
        topups: 'Пополнение',
      },
    },
    categorization: {
      referralKeywords: [
        'реферал',
        'рефераль',
        'referral',
        'процент',
        'bonus_percent',
      ],
    },
    toasts: {
      loadError: 'Не удалось загрузить доходы',
    },
  },
  legal: {
    modalAriaLabel: 'Пользовательское соглашение и политики',
    closeButtonAriaLabel: 'Закрыть окно пользовательского соглашения',
    agreementTitle: 'Пользовательское соглашение',
    agreementSubtitle: 'Выберите раздел пользовательского соглашения.',
    offerButton: 'Публичная оферта',
    refundButton: 'Политика возврата',
  },
  subscriptions: {
    landing: {
      title: 'Подписки',
      noActiveDescription: 'У вас нет активной подписки. Приобретите подписку, нажав кнопку ниже.',
      selectPlan: 'Выбрать тариф',
      selectNewPlan: 'Выбрать новый тариф',
      trialOffer: {
        title: 'Воспользуйтесь всеми функциями Astride VPN бесплатно.',
        activateTrialButton: 'Активировать бесплатно',
        activateTrialButtonAriaLabel: 'Активировать бесплатный пробный период',
        backgroundImageAlt: 'Иллюстрация бесплатного периода Astride VPN',
        trialHint: 'Бесплатно 3 дня, далее от 159 ₽ в мес.',
        trialHintTemplate: 'Бесплатно {days} {dayWord}, далее от {price} ₽ в мес.',
        dayWords: {
          one: 'день',
          few: 'дня',
          many: 'дней',
        },
      },
      openDetailsAriaLabel: 'Открыть страницу выбранной подписки',
      activeStubTitle: 'Раздел подписок в разработке',
      activeStubDescription: 'У вас есть активные подписки. Полный экран управления скоро появится.',
    },
    selected: {
      pageAriaLabel: 'Страница выбранной подписки',
      packagePrefix: 'Подписка',
      fallbackTitle: 'Stride VPN',
      fallbackPackageName: 'Pro',
      copyLinkAriaLabel: 'Скопировать ссылку подписки',
      openInstallGuideAriaLabel: 'Открыть руководство по установке',
      expiredState: {
        extendButton: 'Продлить подписку',
        description: 'Ваша подписка истекла. Чтобы продолжить пользоваться сервисом, продлите ее. Иначе она будет удалена.',
        trialDescription: 'Вы оформили подписку по бесплатному предложению. У вас есть возможность продолжить пользоваться сервисом с платным доступом. Иначе она будет удалена. Повторная активация пробной подписки невозможна.',
      },
      rows: {
        devices: 'Устройств',
        remaining: 'Осталось',
        until: 'До',
      },
    },
    autopayment: {
      ariaLabel: 'Страница автопополнения подписки',
      description: 'Управляйте автоматическим списанием средств за подписку до окончания срока действия.',
      openBalance: 'Открыть баланс',
      sections: {
        periodTitle: 'Действие',
        chargeTitle: 'Время списания средств',
      },
      rows: {
        expiresAt: 'Дата окончания',
        autopayment: 'Автоплатёж',
        autopaymentInTemplate: 'Через {days} {dayWord}',
        chargeInTemplate: '{days} {dayWord}',
      },
      actions: {
        enableAutopayment: 'Активировать автоплатёж',
        chargeBefore: 'Списывать за',
      },
      dayWords: {
        one: 'день',
        few: 'дня',
        many: 'дней',
      },
      toasts: {
        chargePeriodSelectionSoon: 'Выбор периода списания скоро появится',
      },
      chargeLeadDaysModal: {
        ariaLabel: 'Окно выбора периода списания',
        closeButtonAriaLabel: 'Закрыть окно выбора периода списания',
        cancelButton: 'Отмена',
      },
    },
    profileTitle: 'Подписки профиля',
    profileDescription: 'Вы можете управлять вашими подписками.',
    profileModalAriaLabel: 'Подписки пользователя',
    emptyModalAriaLabel: 'Список подписок',
    emptyTitle: 'Подписок пока нет',
    emptyDescription: 'Здесь будут отображаться все ваши доступные подписки.',
    selectPlan: 'Выбрать тариф',
    listTitle: 'Подписки',
    refresh: 'Обновить',
    activeStatus: 'подписка активна',
    expiredStatus: 'подписка истекла',
    untilDatePrefix: 'До',
    unlimitedTraffic: 'Безлимитно',
    activationStatus: 'активация',
    deviceWords: {
      one: 'устройство',
      few: 'устройства',
      many: 'устройств',
    },
    extend: {
      modalAriaLabel: 'Продление времени подписки',
      closeButtonAriaLabel: 'Закрыть окно продления времени',
      promptTitle: 'На какой срок продлить?',
      promptDescription: 'Выберите дополнительное время работы вашей подписки.',
      paymentDescriptionTemplate: 'Продление на {period} ({package})',
      unavailableOptions: 'Варианты продления недоступны',
      paymentLinkUnavailable: 'Ссылка на оплату временно недоступна',
      paymentCreateError: 'Ошибка при создании платежа',
      fallbackPackageName: 'Подписка',
    },
    detail: {
      modalAriaLabel: 'Детали подписки',
      keyTitlePrefix: 'Ключ',
      packagePrefix: 'Пакет',
      tariffLabel: 'Тариф',
      statusLabel: 'Статус',
      activeShort: 'Активно',
      expiredShort: 'Истекло',
      countryLabel: 'Страна',
      trafficLimitLabel: 'Лимит трафика',
      devicesLabel: 'Устройства',
      devicesLimitPrefix: 'до',
      daysLeftLabel: 'Оставшееся время',
      reportProblem: 'Сообщить о проблеме',
      addDevices: 'Добавить устройства',
      extendTime: 'Продлить время',
      noAccessKey: 'Ключ доступа недоступен',
      dayWords: {
        one: 'день',
        few: 'дня',
        many: 'дней',
      },
    },
    qrPage: {
      scanInstruction: 'Наведите камеру устройства или сканируйте в приложении Happ',
      shareButton: 'Поделиться',
      failedToShare: 'Не удалось поделиться',
      imageAlt: 'QR-код подписки',
      shareTitle: 'StrideVPN Подписка',
      shareText: 'Мой QR-код для подключения к VPN',
      fallbackSubscriptionName: 'vpn-config',
      avatarAlt: 'Аватар пользователя',
    },
    page: {
      subtitle: 'Вы можете управлять своей подпиской.',
      subscriptionLinkLabel: 'Ссылка подписки',
      daysLeftLabel: 'Осталось',
      settingsAccessTitle: 'Настройки доступа',
      tabs: {
        access: 'Доступ',
        users: 'Пользователи',
        other: 'Другое',
      },
      actions: {
        generateNewLink: 'Сгенерировать новую ссылку',
        addDevices: 'Добавить устройства',
        extendTime: 'Продлить время',
        reportProblem: 'Сообщить о проблеме',
      },
      regenerateModal: {
        ariaLabel: 'Подтверждение генерации новой ссылки подписки',
        closeButtonAriaLabel: 'Закрыть окно генерации новой ссылки',
        title: 'Сгенерировать новую ссылку?',
        description:
          'Предыдущая ссылка будет безвозвратно удалена. Вам потребуется повторно активировать её на ваших устройствах.',
        confirmButton: 'Сгенерировать',
      },
      resetSessionsModal: {
        ariaLabel: 'Подтверждение сброса активных сессий подписки',
        closeButtonAriaLabel: 'Закрыть окно сброса активных сессий',
        title: 'Сбросить активные сессии?',
        description:
          'Это отключит все устройства, подключенные к вашей конфигурации VPN. Чтобы подключиться снова, обновите подписку в Happ.',
        confirmButton: 'Сбросить сессии',
      },
      sections: {
        access: {
          title: 'Настройки доступа',
          actions: {
            generateNewLink: 'Сгенерировать новую ссылку',
            addDevices: 'Добавить устройства',
            extendTime: 'Продлить время',
          },
        },
        users: {
          title: 'Управление пользователями',
          actions: {
            devices: 'Устройства',
            generateNewLink: 'Сгенерировать новую ссылку',
            resetActiveSessions: 'Сбросить активные сессии',
          },
        },
        other: {
          title: 'Другие параметры',
          actions: {
            freeze: 'Приостановить подписку',
            addComment: 'Добавить комментарий',
            subscriptionQr: 'QR-код подписки',
          },
        },
        common: {
          actions: {
            autopayment: 'Автопополнение',
          },
        },
      },
      toasts: {
        generateLinkFailed: 'Не удалось обновить ссылку. Попробуйте еще раз.',
        resetActiveSessionsFailed: 'Не удалось сбросить активные сессии. Попробуйте еще раз.',
        supportBotUnavailable: 'Ссылка на поддержку недоступна',
        resetActiveSessionsUnavailable: 'Сброс активных сессий пока недоступен',
        freezeUnavailable: 'Приостановка подписки пока недоступна',
        addCommentUnavailable: 'Добавление комментария пока недоступно',
        subscriptionQrUnavailable: 'QR-код подписки пока недоступен',
      },
      errors: {
        subscriptionNotFound: 'Подписка не найдена',
      },
      aria: {
        pageLabel: 'Страница подписки',
        copySubscriptionLinkButton: 'Скопировать ссылку подписки',
        loadingState: 'Загрузка страницы подписки',
      },
    },
    devicesPage: {
      pageAriaLabel: 'Страница устройств подписки',
      description: 'В приложении Happ вы можете подключить любое устройство к вашей подписке.',
      descriptionPrefix: 'В приложении ',
      descriptionAppName: 'Happ',
      descriptionSuffix: ' вы можете подключить любое устройство к вашей подписке.',
      addMoreDevicesButton: 'Добавить больше устройств',
      activeSessionsTitle: 'Активные сеансы',
      emptySessions: 'Активных сеансов пока нет',
      unknownDeviceName: 'Неизвестное устройство',
      unknownClient: 'Неизвестный клиент',
      unknownLocation: 'Неизвестно',
      sessionsLoadFailed: 'Не удалось загрузить активные сеансы',
      autoCloseTitle: 'Автоматически завершать сеанс',
      autoCloseInactiveLabel: 'Если сеанс неактивен',
      autoClosePeriodLabel: '1 месяц',
      autoCloseSettingUnavailable: 'Настройка авто-завершения скоро появится',
      autoCloseUpdateFailed: 'Не удалось обновить период неактивности',
      autoCloseModal: {
        ariaLabel: 'Выбор периода неактивности сеанса',
        closeButtonAriaLabel: 'Закрыть выбор периода неактивности',
        options: {
          day: '24 часа',
          week: '1 неделя',
          month: '1 месяц',
          quarter: '3 месяца',
        },
        cancelButton: 'Отмена',
      },
      lastSeenUnknown: 'Неизвестно',
      lastSeenJustNow: 'только что',
      agoLabel: 'назад',
      minuteWords: {
        one: 'минута',
        few: 'минуты',
        many: 'минут',
      },
      hourWords: {
        one: 'час',
        few: 'часа',
        many: 'часов',
      },
      dayWords: {
        one: 'день',
        few: 'дня',
        many: 'дней',
      },
      deviceModal: {
        ariaLabel: 'Детали сеанса устройства',
        closeButtonAriaLabel: 'Закрыть детали устройства',
        rows: {
          activationDate: 'Дата активации',
          application: 'Приложение',
          geolocation: 'Геопозиция',
        },
        geolocationHint: 'Геопозиция определяется приблизительно по IP-адресу сеанса.',
        terminateSessionButton: 'Завершить сеанс',
        terminateSessionFailed: 'Не удалось завершить сеанс',
        invalidSessionIdentifier: 'Некорректный идентификатор сеанса',
        terminateSessionUnavailable: 'Завершение сеанса скоро появится',
      },
    },
    extendDevices: {
      modalAriaLabel: 'Добавление устройств к подписке',
      closeButtonAriaLabel: 'Закрыть окно добавления устройств',
      promptTitle: 'Сколько устройств добавить?',
      promptDescription: 'Выберите, сколько активных устройств будет задействовано для вашей подписки.',
      promptDescriptionPrefix: 'Укажите, сколько активных устройств будет задействовано для вашей подписки.',
      currentUsagePrefix: 'Сейчас',
      currentUsageTemplate: '{prefix}: {current}/{max}',
      paymentDescriptionTemplate: 'Доп. устройства до {count} ({tariffLabel}: {package})',
      optionLabelTemplate: '{count} {devicesWord} - {price}',
      limitReached: 'Достигнут лимит устройств',
      buttonPrefix: 'Всего',
      currencyLabel: 'RUB',
      periodLabel: 'Добавление устройств',
      paymentLinkUnavailable: 'Ссылка на оплату временно недоступна',
      paymentCreateError: 'Ошибка при создании платежа',
      fallbackPackageName: 'Подписка',
    },
  },
  support: {
    title: 'Поддержка',
    subtitle: 'Мы рядом и поможем с любым вопросом',
    channelLabel: 'Канал связи',
    channelTitle: 'Telegram поддержка 24/7',
    channelDescription: 'Напишите нам в чат, и мы ответим в течение нескольких минут.',
    openChatButton: 'Открыть чат поддержки',
    faqTitle: 'Частые вопросы',
    faq: {
      installQuestion: 'Как установить конфиг?',
      installAnswer: 'После оплаты вы получите доступ в профиле.',
      vpnIssueQuestion: 'Что делать, если VPN не работает?',
      vpnIssueAnswer: 'Обновите конфиг в каталоге или напишите в поддержку.',
      refundQuestion: 'Можно ли вернуть оплату?',
      refundAnswer: 'Мы решаем такие вопросы индивидуально — свяжитесь с нами.',
    },
    contactsTitle: 'Контакты',
    contacts: {
      email: 'Почта',
      responseTime: 'Время ответа',
      responseTimeValue: '5-15 минут',
    },
  },
  appStore: {
    errors: {
      fetchConfigs: 'Не удалось загрузить конфиги',
      fetchPackages: 'Не удалось загрузить пакеты',
      fetchPayments: 'Не удалось загрузить платежи',
      fetchSubscriptions: 'Не удалось загрузить подписки',
      fetchTransactions: 'Не удалось загрузить транзакции',
    },
  },
  errorBoundary: {
    title: 'Что-то пошло не так',
    description: 'Произошла ошибка при загрузке этой страницы. Попробуйте обновить ее.',
    reload: 'Обновить',
    goHome: 'На главную',
  },
} as const
